export function fire (...args) {
  const Swal = this
  return new Swal(...args)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/sweetalert2/src/staticMethods/fire.js
// module id = null
// module chunks = 